const CLIENT = process.env.REACT_APP_CLIENT;
export default {
  media: "https://stormborn-strapi.tr4ns.com",
  logo: "/assets/" + CLIENT + "/logo.png",
  logo_lg_pdf: "/assets/" + CLIENT + "/logo-lg-pdf.jpg",
  logo_pdf: "/assets/" + CLIENT + "/logo-pdf.png",
};
